var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":""}},[_c('pao-search',{ref:"paoSearch",attrs:{"searchOnly":true},scopedSlots:_vm._u([{key:"default",fn:function({displaySpinner, paoList}){return [_c('pao-list',{attrs:{"displaySpinner":displaySpinner}},[_c('pao-list-tabs',{attrs:{"paoList":paoList},on:{"changePage":_vm.changePage}})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }